module.exports = __webpack_public_path__ + "img/MDI-communication-management.e35b5977.svg";